import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import { trans } from "../../../helpers/index";
import ApiManager from "../../../apiManager/index";
import FormMiddlewareError from "../../Fragments/FormMiddlewareError";
import SimpleCrypto from "simple-crypto-js";
import config from "../../../baseConfig/index";
import ErrorModal from "../../Fragments/ErrorModal";

class B2bChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      _token: this.props.csrf_token.data,
      showErrorModal: false,
      buttonDisabled: false,
      password: "",
      confirmPassword: "",
      formResponse: "",
    };
  }

  errorModal() {
    if (!this.state.showErrorModal) {
      return "";
    }

    return (
      <ErrorModal
        title={trans(this.props.trans, "error.modal.title")}
        description={trans(this.props.trans, "error.modal.description")}
        action_text={trans(this.props.trans, "error.modal.action_text")}
      />
    );
  }

  reSendData() {
    this.setState({ buttonDisabled: true });

    ApiManager.getRequest({}, "/csrf-token").then(
      (resolve) => {
        this.props.setTokenAction(resolve.data);
        this.setState({ _token: resolve.data.data });
        this.sendData();
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  sendData() {
    this.setState({ buttonDisabled: true });

    ApiManager.postRequest(
      {
        jwt: this.props.b2bJwt,
        password: this.state.password,
        password_confirmation: this.state.confirmPassword,
        _token: this.state._token,
      },
      "/b2b" + (this.props.isCurator ? "curator" : "") + "/update-password"
    ).then(
      (resolve) => {
        // @test
        // resolve.data = {"status": "OK"};

        this.setState({
          buttonDisabled: false,
          formResponse: resolve.data,
        });

        if (resolve.data.status === "OK") {
          const simpleCrypto = new SimpleCrypto(config.simpleCryptoSecretKey);
          this.props.cookies.set(
            "loginTokenB2b",
            simpleCrypto.encrypt(this.props.b2bJwt),
            { path: config.urlPrefix }
          );

          if (this.props.isCurator) {
            this.props.cookies.set("loginByCurator", 1, {
              path: config.urlPrefix,
            });
          }

          this.props.history.push(config.urlPrefix + "b2b");
        } else if (resolve.data.status === "CSRF_TOKEN_MISMATCH") {
          this.reSendData();
        }
      },
      (reject) => {
        this.setState({ showErrorModal: true });
      }
    );
  }

  render() {
    let errorBox = "";

    if (this.state.formResponse !== "") {
      if (this.state.formResponse.status === "INVALID_DATA") {
        if (this.state.formResponse.errors.hasOwnProperty("password")) {
          errorBox = (
            <FormMiddlewareError
              message={this.state.formResponse.errors.password}
            />
          );
        }
      }

      if (
        this.state.formResponse.status === "ERROR" ||
        this.state.formResponse.status === "NOT_FOUND"
      ) {
        errorBox = (
          <FormMiddlewareError message={this.state.formResponse.message} />
        );
      }
    }

    return (
      <div className="form">
        <form
          action="#"
          method="post"
          onSubmit={(event) => {
            event.preventDefault();
            this.sendData();
          }}
        >
          <p className="form__top-desc">
            {trans(this.props.trans, "b2b.change_password_form.description")}
          </p>
          <div className="form__form-box">
            <label className="form__label db fs11" htmlFor="tel-number">
              {trans(
                this.props.trans,
                "b2b.change_password_form.fullname.label"
              )}
            </label>
            <div className="form__field-out pr">
              <input
                className="form__field form__field--right-space fs13"
                type="text"
                disabled={true}
                value={this.props.b2bEmail}
              />
              <div className="form__info-box pa">
                <span className="form__info sprite db"> </span>
                <div className="form__info-txt fs11 pa">
                  {trans(
                    this.props.trans,
                    "b2b.change_password_form.fullname.description"
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="form__form-box">
            <label className="form__label  db fs11" htmlFor="new-password">
              {trans(
                this.props.trans,
                "b2b.change_password_form.new_password.label"
              )}
            </label>
            <div className="form__field-out pr">
              <input
                className="form__field form__field--right-space fs13"
                type="password"
                placeholder={trans(
                  this.props.trans,
                  "b2b.change_password_form.new_password.placeholder"
                )}
                onChange={(event) => {
                  this.setState({ password: event.target.value.trim() });
                }}
                value={this.state.password}
              />
              <div className="form__info-box pa">
                <span className="form__info sprite db"> </span>
                <div className="form__info-txt fs11 pa">
                  {trans(
                    this.props.trans,
                    "b2b.change_password_form.new_password.description"
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="form__form-box">
            <label className="form__label  db fs11" htmlFor="re-new-password">
              {trans(
                this.props.trans,
                "b2b.change_password_form.repeat_password.label"
              )}
            </label>
            <div className="form__field-out pr">
              <input
                className="form__field form__field--right-space fs13"
                id="re-new-password"
                type="password"
                placeholder={trans(
                  this.props.trans,
                  "b2b.change_password_form.repeat_password.placeholder"
                )}
                onChange={(event) => {
                  this.setState({ confirmPassword: event.target.value.trim() });
                }}
                value={this.state.confirmPassword}
              />
              <div className="form__info-box pa">
                <span className="form__info sprite db"> </span>
                <div className="form__info-txt fs11 pa">
                  {trans(
                    this.props.trans,
                    "b2b.change_password_form.repeat_password.description"
                  )}
                </div>
              </div>
            </div>
          </div>
          {errorBox}
          <button
            className={`form__submit-btn btn btn--yellow fs17${
              this.state.buttonDisabled ? " btn--loading" : ""
            }`}
            type="submit"
            disabled={this.state.buttonDisabled}
          >
            {trans(this.props.trans, "b2b.change_password_form.button.label")}
          </button>
        </form>
        {this.errorModal()}
      </div>
    );
  }
}

export default withRouter(withCookies(B2bChangePassword));
